import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/userAgreement',
    name: 'UserAgreement',
    component: () => import('@/views/userAgreement.vue')
  },
  {
    path: '/personalCenter',
    name: 'PersonalCenter',
    component: () => import('@/views/personalCenter.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/profile.vue')
  },
  {
    path: '/pointsMall',
    name: 'PointsMall',
    component: () => import('@/views/pointsMall.vue')
  },
  {
    path: '/goodsDetail',
    name: 'GoodsDetail',
    component: () => import('@/views/goodsDetail.vue')
  },
  {
    path: '/address',
    name: 'Address',
    component: () => import('@/views/address.vue')
  },
  {
    path: '/addressEdit/:id?',
    name: 'AddressEdit',
    component: () => import('@/views/addressEdit.vue')
  },
  {
    path: '/orderConfirm',
    name: 'OrderConfirm',
    component: () => import('@/views/orderConfirm.vue')
  },
  {
    path: '/orderResult/:status',
    name: 'OrderResult',
    component: () => import('@/views/orderResult.vue')
  },
  {
    path: '/exchangeList',
    name: 'ExchangeList',
    component: () => import('@/views/exchangeList.vue')
  },
  {
    path: '/orderDetail/:id?',
    name: 'OrderDetail',
    component: () => import('@/views/orderDetail.vue')
  },
  {
    path: '/pointsDetail',
    name: 'PointsDetail',
    component: () => import('@/views/pointsDetail.vue')
  },
  {
    path: '/memberGift',
    name: 'MemberGift',
    component: () => import('@/views/memberGift.vue')
  },
  {
    path: '/changePhone',
    name: 'ChangePhone',
    component: () => import('@/views/changePhone.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const publicPages = ['/login', '/userAgreement']
  const isPublicPage = publicPages.includes(to.path)

  if (!token && !isPublicPage) {
    next('/login')
  } else if (token && to.path === '/login') {
    next('/personalCenter')
  } else {
    next()
  }
})

export default router
